import 'style-loader!./slide2.component.scss';
import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { UserService } from 'app/theme/services/user.service';
import { AlertService } from 'app/theme/services/alert.service';
import { Router } from '@angular/router';
import { ChannelService } from 'app/theme/services/channel.service';
import { IConfirmationCodeResponse } from 'app/theme/models/response';
import { User, Status, IKeyboard, Task, Copy } from 'app/theme/models/user.model';
import { LanguageService } from 'app/theme/services/language.service';
import { CodeService } from 'app/theme/services/code.service';
import { ElementRef, ViewChild } from '@angular/core';



@Component({
    selector: 'reg-slide2',
    templateUrl: './slide2.component.html',
    encapsulation: ViewEncapsulation.None
})
export class VerificationComponent implements OnInit {
    @Output('fireNext') fireNext: EventEmitter<boolean> = new EventEmitter<boolean>();
    prefix: string;
    codice: string;
    Labels: any;
    alerts: any;
    user: User;
    smsService: boolean = false;
    onVerifying: boolean = false;
    source: string;

    public constructor(
        protected router: Router,
        protected _userService: UserService,
        protected _alterService: AlertService,
        protected _channelService: ChannelService,
        protected _langService: LanguageService,
        protected _codeService: CodeService
    ) {

    }

    /* --------------------- */

    public ngOnChanges() { }
    public ngOnDestroy() { }

    //CR ACCESSIBILITà GESTIONE AUTOCOMPLETE START
    ngAfterViewInit() {
        const fields = ['cap', 'city', 'province', 'address', 'civico','via'];
        const disableForAll = this.source === 'tablet' || this.source === 'totem' || this.source === 'tablet-new' || this.source === 'totem-new';
        
        if (disableForAll) {
            // Converte NodeList in un array e applica la funzione
            Array.from(document.querySelectorAll('input')).forEach((input: HTMLInputElement) => {
            this.disableAutocomplete(input.id); // Usa l'id se disponibile
            });
        
        } else {
            // Disattiva solo per i campi specificati
            fields.forEach(field => this.disableAutocomplete(field));
        }
        }
      
    
        private disableAutocomplete(elementId: string): void {
            const inputElement = document.getElementById(elementId) as HTMLInputElement;
            let sottostringa = "mat-";        

            if (!elementId.toLowerCase().includes(sottostringa.toLowerCase())) {
                if (inputElement) {
                    // Disattiva tutti gli attributi legati all'autocomplete
                    inputElement.setAttribute('autocomplete', 'new-password'); // Alternativa più efficace a "off"
                    inputElement.setAttribute('autocorrect', 'off');
                    inputElement.setAttribute('autocapitalize', 'off');
                    inputElement.setAttribute('spellcheck', 'false');
                    
                    // Cambia dinamicamente il nome e l'ID per evitare suggerimenti memorizzati
                    const newName = elementId + '_' + new Date().getTime();
                    inputElement.setAttribute('name', newName);
                    inputElement.setAttribute('id', newName);
        
                    // Disattiva la gestione automatica degli indirizzi di Chrome e password manager
                    inputElement.setAttribute('data-lpignore', 'true'); // LastPass
                    inputElement.setAttribute('data-form-type', 'other');
                    inputElement.setAttribute('aria-autocomplete', 'none');
                
                    // Nasconde suggerimenti tramite CSS inline
                    // inputElement.style.setProperty('display', 'inline-block', 'important');
                    inputElement.style.setProperty('position', 'relative', 'important');
                    inputElement.style.setProperty('z-index', '9', 'important'); //Abbastanza da sovrapporre i campi non abbastanza da sovrapporre il resto
                    
                    // Ritarda la modifica dell'ID per "ingannare" il browser
                    setTimeout(() => {
                        inputElement.setAttribute('id', elementId);
                    }, 1000);  
                }              
            }
        }  

		@ViewChild('mainContent') mainContent: ElementRef | null = null;
        skipToMain(event: Event) {
            event.preventDefault(); // Evita il comportamento predefinito del link
            
            if (this.mainContent) {
              setTimeout(() => {
                this.mainContent.nativeElement.focus();
              }, 0); // Timeout per garantire che Angular abbia reso l'elemento visibile
            }
          }
    //CR ACCESSIBILITà GESTIONE AUTOCOMPLETE END


    public ngOnInit() {
        this._userService.getUser().subscribe((user) => {
            if (user) {
                this.user = Copy(user);
                if (this.user.info.canale == "totem" || this.user.info.canale == "tablet" || this.user.info.canale == "totem-new" || this.user.info.canale == "tablet-new" )
                    this.smsService = true;

                if (this.user.info.canale == "totem" || this.user.info.canale == "totem-new")
                    this.createKeyboard();
            }
        });
        this._userService.getPrefixNumber().subscribe((prefix) => {
            this.prefix = prefix;
        })
        this._langService.translatePageIndex(5).subscribe((mylabels) => {
            this.Labels = mylabels;
        });
        this._langService.subscribeAlerts().subscribe((alerts) => {
            if (alerts) {
                this.alerts = alerts;
            }
        })

        this._channelService.getSource().subscribe((source: string) => {
            if (source) {
                this.source = source;
            }
        })
    }

    createKeyboard() {
        if (this.user.info.canale == "totem" || this.user.info.canale == "totem-new") {
            require.ensure(['app/theme/assets/scripts/VirtualKeyboard.js'], require => {
                var virtualKeyboard = require('app/theme/assets/scripts/VirtualKeyboard.js');
                var keyboard1: IKeyboard = { options: {}, target: null, container: ".PageSlide2" };
                let vk = new virtualKeyboard.default(keyboard1);
                vk.init(".PageSlide2");
            });
        }
    }
    replaceWith(content: string, replacedWith): string {
        return content.replace("XXXX", replacedWith);
    }
    onRecapitoTelefonico() {
        this._codeService.SendCodeRequest("", this.user.contacts.cellulare, this.user.info.canale)
            .then(() => {
                this._alterService.showModalAlertInfo("", this.replaceWith(this.alerts.alert_8, this.user.contacts.cellulare))
            })
            .catch(() => {
                this._alterService.showModalAlertWarning("", this.alerts.alert_17, null, 'X')
            })
    }
    onRecapitoEmail() {
        this._codeService.SendCodeRequest(this.user.contacts.email, "", this.user.info.canale)
            .then(() => {
                this._alterService.showModalAlertInfo("", this.replaceWith(this.alerts.alert_9, this.user.contacts.email))
            })
            .catch(() => {
                this._alterService.showModalAlertWarning("", this.alerts.alert_17, null, 'X')
            })
    }
    onWriteCode() {
        if ((this.codice + "").length == 6 && !this.onVerifying) {
            this.onVerifying = true;
            let btn = $('.verifica').first();
            if (btn) btn.click();
            else this.fireNext.emit(true);
        }
    }

    onVerifyCodiceInside() {
        if ((this.codice + "").length == 6) {
            this.onWriteCode();
        } else {
            this._alterService.showModalAlertWarning(this.Labels.title, this.alerts.alert_35, null, 'X')
        }
    }
    onVerifyCodice() {
        this.onVerifying = true;
        return new Promise((resolve, reject) => {
            if (this.codice) {
                this._codeService.VerifyCodeControl(this.user.contacts.email, this.prefix + this.user.contacts.cellulare, this.codice)
                    .then((data: IConfirmationCodeResponse) => {
                        if (data.isValid) {
                            if (data.email) this.user.contacts.emailStatus = Status.Valid;
                            else this.user.contacts.cellulareStatus = Status.Valid;
                            this._userService.setUser(this.user);
                            resolve(data)
                        } else {
                            reject({ type: "warning", title: this.Labels.title, content: this.alerts.alert_18, btn: this.Labels.cancel })
                        }
                        this.onVerifying = false;
                    })
                    .catch((error) => {
                        if(this.source=='app'){
                            //console.log("chiamata script KO VerifyCodeControl");
                            self.postMessage(JSON.stringify({"type": "KO", payload: {"username": "", "password": "", "message":this.alerts.alert_32}}),'*');
                        }
                        reject({ type: "SERVER", title: "SERVER", content: this.alerts.alert_32, btn: this.Labels.cancel });
                        this.onVerifying = false;
                    })
            } else {
                reject({ type: "warning", title: this.Labels.title, content: this.alerts.alert_19, btn: this.Labels.cancel });
                this.onVerifying = false;
            }
        })
    }

    onExit() {
        var refDialog = this._alterService.showModalConfirm(this.Labels.exit, this.alerts.alert_21, this.Labels.exit, 'X')
        refDialog.result
            .then(data => {
                if (this.source == 'totem-new' || this.source == 'tablet-new' || this.source == 'tablet-new' || this.source == 'totem-new')
                  window.top.location.href = decodeURIComponent(window.location.href);
                else if (this.source == 'app') {
                    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                        self.postMessage(JSON.stringify({ "type": "CLOSE", payload: { "username": "", "password": "" } }), '*');
                        document.body.classList.remove('modal-open');
                        (<any>window).ReactNativeWebView.postMessage('closeWebView');
                    }
                    else  self.postMessage(JSON.stringify({ "type": "CLOSE", payload: { "username": "", "password": "" } }), '*');
                    
                }
                else 
                    window.location.replace(decodeURIComponent(window.location.href));
                
                //window.history.go(0);
            })
            .catch(data => { document.body.classList.remove('modal-open');})
    }
}



// WEBPACK FOOTER //
// ./src/app/theme/components/slide2/slide2.component.ts